import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ScannerServiceProvider } from '../../providers/scanner-service/scanner-service';
import _ from 'lodash';

@Component({
  selector: 'drivers-license-scanner',
  templateUrl: 'drivers-license-scanner.html',
})
export class DriversLicenseScannerComponent implements ScannerDelegate {

  @Input() showScanner;
  @Output() scanOutput = new EventEmitter();
  text: string;
  DriversLicenseData = {
    first_name: null,
    last_name: null,
    gender: null,
    address: null,
    city: null,
    province: null,
    postal_code: null,
    dob: null
  };

  constructor(public scanner: ScannerServiceProvider) {}

  scanDriversLicense(event) {
    this.scanner.delegate = this;
    this.scanner.start();
  }

  public didScan(session: ScanSession) {
    let strDLData = session.newlyRecognizedCodes[0].data;
    this.scanner.cancel();
    if(_.includes(strDLData, '%BC')) {

      let dlArray = strDLData.split('^');

      let nameArray = dlArray[1].split(',$');
      this.DriversLicenseData.first_name = nameArray[1]
      this.DriversLicenseData.last_name = nameArray[0];
      this.DriversLicenseData["gender"] = "MALE"

      let addressArray = dlArray[2].split('$');
      console.log('ADD Array: ', addressArray);
      console.log('SPLIT ADD', addressArray[1].split('BC'));
      let cityProvPostalArray = addressArray[1].split('BC');
      console.log('ADD Array 0: ', addressArray[0]);
      console.log('ADD Array 1: ', addressArray[1]);
      console.log('CPP Array: ', cityProvPostalArray);

      this.DriversLicenseData.address = addressArray[0];
      this.DriversLicenseData.province = 'BC';
      this.DriversLicenseData.city = cityProvPostalArray[0].trim();
      this.DriversLicenseData.postal_code = cityProvPostalArray[1].trim();

      let dobArray = dlArray[3].split('=');
      console.log('DOB Array', dobArray);
      this.DriversLicenseData.dob = this.getDateFormat(dobArray[1].slice(4));
      console.log('DOB: ', this.DriversLicenseData.dob);
  
      let gender = dobArray[2].slice(32, 33);
      console.log('Gender: ', gender);
      if(gender === 'F') this.DriversLicenseData["gender"] = "FEMALE";
      else this.DriversLicenseData["gender"] = "MALE";
    }
    else {
      this.parseDriversLicense(strDLData);
    }
    console.log('DL: ', this.DriversLicenseData);
    this.scanOutput.emit(this.DriversLicenseData);
  }

  goForIt() {
    this.scanOutput.emit('Running from component');
  }
  

  parseDriversLicense(scandata: string) {
    console.log("DL Scan String: ", scandata);
    var defaultOptions = {suppressErrors: true};
    let data: any;
    data = this.parseCode128(scandata, defaultOptions);
    console.log("Drivers License Parsed:", data);

    if(data.DCT)  this.DriversLicenseData["first_name"] = data.DCT.split(",")[0];
    if(data.DAC)  this.DriversLicenseData["first_name"] = data.DAC.split(",")[0];

    // Get Last Name from DL
    if(data.DCS)  this.DriversLicenseData["last_name"] = data.DCS.split(",")[0];
    if(data.DAB)  this.DriversLicenseData["last_name"] = data.DAB.split(",")[0];

    // Get DOB from DL
    this.DriversLicenseData["dob"] = data.DBB;

    // Get Gender from DL
    this.DriversLicenseData["gender"] = data.DBC;

    this.DriversLicenseData["address"] = data.DAG.split(",")[0];

    this.DriversLicenseData["city"] = data.DAI.trim();
    if(data.DAJ)  {
      this.DriversLicenseData["province"] = data.DAJ.trim();
    }
    else {
      this.DriversLicenseData["province"] = "QC";
    }
      
    this.DriversLicenseData["postal_code"] = data.DAK.trim();
  }







lineSeparator = "\n";

parseCode128(str, options: object) {
  const props = {};
  const rawLines = str.trim().split(this.lineSeparator);
  const lines = rawLines.map(rawLine => this.sanitizeData(rawLine));
  let started;
  lines.slice(0, -1).forEach(line => {
    if (!started) {
      if (line.indexOf("ANSI ") === 0) {
        started = true;
      }
      return;
    }

    let code = this.getCode(line);
    let value = this.getValue(line);
    let key = this.getKey(code);
    if (!key) {
      if (options['suppressErrors']) {
        return;
      } else {
        throw new Error("unknown code: " + code);
      }
    }

    if (this.isSexField(code)) value = this.getSex(code, value);

    props[code] = this.isDateField(key) ? this.getDateFormat(value) : value;
  });

  return props;
};

sanitizeData = rawLine => rawLine.match(/[\011\012\015\040-\177]*/g).join('').trim();

getCode = line => line.slice(0, 3);
getValue = line => line.slice(3);
getKey = code => this.CodeToKey[code];

isSexField = code => code === "DBC";
getSex = (code, value) => ((value === "1" || value ==="M") ? "MALE" : "FEMALE");

isDateField = key => key.indexOf("date") === 0;
getDateFormat = value => {
  const parts = [value.slice(0, 4), value.slice(4, 6), value.slice(6)];
  return parts.join("-");
};

CodeToKey: Object = {
  DCA: 'jurisdictionVehicleClass',
  DCB: 'jurisdictionRestrictionCodes',
  DCD: 'jurisdictionEndorsementCodes',
  DBA: 'dateOfExpiry',
  DAB: 'lastName_ab',
  DCS: 'lastName',
  DAC: 'firstName_qc',
  DCT: 'firstName',
  DAD: 'middleName',
  DBD: 'dateOfIssue',
  DBB: 'dateOfBirth',
  DBC: 'sex',
  DAY: 'eyeColor',
  DAU: 'height',
  DAG: 'addressStreet',
  DAI: 'addressCity',
  DAJ: 'addressState',
  DAK: 'addressPostalCode',
  DAQ: 'documentNumber',
  DCF: 'documentDiscriminator',
  DCG: 'issuer',
  DDE: 'lastNameTruncated',
  DDF: 'firstNameTruncated',
  DDG: 'middleNameTruncated',
  // optional
  DAZ: 'hairColor',
  DAH: 'addressStreet2',
  DCI: 'placeOfBirth',
  DCJ: 'auditInformation',
  DCK: 'inventoryControlNumber',
  DBN: 'otherLastName',
  DBG: 'otherFirstName',
  DBS: 'otherSuffixName',
  DCU: 'nameSuffix', // e.g. jr, sr
  DCE: 'weightRange',
  DCL: 'race',
  DCM: 'standardVehicleClassification',
  DCN: 'standardEndorsementCode',
  DCO: 'standardRestrictionCode',
  DCP: 'jurisdictionVehicleClassificationDescription',
  DCQ: 'jurisdictionEndorsementCodeDescription',
  DCR: 'jurisdictionRestrictionCodeDescription',
  DDA: 'complianceType',
  DDB: 'dateCardRevised',
  DDC: 'dateOfExpiryHazmatEndorsement',
  DDD: 'limitedDurationDocumentIndicator',
  DAW: 'weightLb',
  DAX: 'weightKg',
  DDH: 'dateAge18',
  DDI: 'dateAge19',
  DDJ: 'dateAge21',
  DDK: 'organDonor',
  DDL: 'veteran'
}
}



// WEBPACK FOOTER //
// ./src/components/drivers-license-scanner/drivers-license-scanner.ts